"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUserArray = exports.validateUser = exports.validateCommentArray = exports.validateComment = exports.validateLabelArray = exports.validateLabel = exports.validateSectionArray = exports.validateSection = exports.validateProjectArray = exports.validateProject = exports.validateTaskArray = exports.validateTask = void 0;
var types_1 = require("../types");
function validateTask(input) {
    return types_1.Task.check(input);
}
exports.validateTask = validateTask;
function validateTaskArray(input) {
    return input.map(validateTask);
}
exports.validateTaskArray = validateTaskArray;
function validateProject(input) {
    return types_1.Project.check(input);
}
exports.validateProject = validateProject;
function validateProjectArray(input) {
    return input.map(validateProject);
}
exports.validateProjectArray = validateProjectArray;
function validateSection(input) {
    return types_1.Section.check(input);
}
exports.validateSection = validateSection;
function validateSectionArray(input) {
    return input.map(validateSection);
}
exports.validateSectionArray = validateSectionArray;
function validateLabel(input) {
    return types_1.Label.check(input);
}
exports.validateLabel = validateLabel;
function validateLabelArray(input) {
    return input.map(validateLabel);
}
exports.validateLabelArray = validateLabelArray;
function validateComment(input) {
    return types_1.Comment.check(input);
}
exports.validateComment = validateComment;
function validateCommentArray(input) {
    return input.map(validateComment);
}
exports.validateCommentArray = validateCommentArray;
function validateUser(input) {
    return types_1.User.check(input);
}
exports.validateUser = validateUser;
function validateUserArray(input) {
    return input.map(validateUser);
}
exports.validateUserArray = validateUserArray;
